import { FormBody, useFormValidationErrorsNotification } from '../../../Form'
import { AuthHelpText } from '../../AuthHelpText'
import { LoginFormBodyActions } from '../LoginFormBodyActions'

import * as styles from './LoginFormBody.module.css'

function LoginFormBody({
  Actions = LoginFormBodyActions,
  ReturnButton,
  actionsProps,
  children,
  helpText,
  returnButtonProps,
  onRemoveNotification,
  onSetNotification,
}) {
  useFormValidationErrorsNotification({
    onRemoveNotification,
    onSetNotification,
  })

  return (
    <FormBody Actions={null} Header={null}>
      {ReturnButton ? <ReturnButton {...returnButtonProps} /> : null}

      {helpText ? (
        <AuthHelpText className={styles.helpText} text={helpText} />
      ) : null}

      {children}

      <Actions {...actionsProps} />
    </FormBody>
  )
}

export default LoginFormBody
